import { gql } from "graphql-request";
import { CONTACT_CORE_FIELDS } from "./fragments";

export const READ_CONTACT_BY_ID = gql`
  query ReadContactByID($id: ID!) {
    readContactByID(id: $id) {
      ${CONTACT_CORE_FIELDS}
      interactions {
        id
        contactID
        type
        direction
        summary
        notes
        meaningful
        happenedAt
      }
    }
  }
`;

export const GET_ALL_CONTACTS = gql`
  query GetAllContacts {
    readAllContacts {
      ${CONTACT_CORE_FIELDS}
    }
  }
`;

export const GET_CONTACT_NAME_LOOKUP = gql`
  query GetContactNameLookup {
    readAllContacts {
      id
      firstName
      lastName
    }
  }
`;

export const READ_CONTACT_MAP_POINTS = gql`
  query ReadContactMapPoints($filter: ContactMapFilterInput) {
    readContactMapPoints(filter: $filter) {
      contactID
      firstName
      lastName
      email
      phone
      companyID
      companyLegalName
      companyTradingName
      industry
      companyStatus
      addressID
      addressLabel
      addressLine1
      town
      postcode
      country
      latitude
      longitude
      isPrimaryAddress
    }
  }
`;
